import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { title: "Strategic Assessment", desc: "Goal alignment and internal readiness audit." },
  { title: "Market Analysis", desc: "Target identification and landscape mapping." },
  { title: "Due Diligence", desc: "Deep-dive operational and financial auditing." },
  { title: "Financial Structuring", desc: "Tax optimization and capital arrangement." },
  { title: "Negotiation", desc: "Terms finalization and deal execution." },
  { title: "Integration Strategy", desc: "Cultural and operational synergy planning." },
  { title: "Optimization", desc: "Continuous value realization and scaling." }
];

const MATimeline = () => {
  return (
    <section className="py-32 bg-brand-black overflow-hidden border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-20">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-4">The Transaction Lifecycle</h2>
          <div className="w-20 h-1 bg-brand-gold"></div>
        </div>

        <div className="relative">
          <div className="absolute top-1/2 left-0 w-full h-[1px] bg-white/10 hidden lg:block -translate-y-1/2"></div>
          
          <div className="grid lg:grid-cols-7 gap-8 relative z-10">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group cursor-default"
              >
                <div className="flex flex-col items-center lg:items-start">
                  <div className="w-12 h-12 rounded-full border-2 border-brand-gold bg-brand-black flex items-center justify-center text-brand-gold font-bold mb-6 group-hover:bg-brand-gold group-hover:text-white transition-all duration-300 shadow-[0_0_15px_rgba(182,141,64,0.3)]">
                    {index + 1}
                  </div>
                  <h4 className="text-white font-bold mb-3 text-center lg:text-left text-sm tracking-tight">{step.title}</h4>
                  <p className="text-gray-500 text-xs text-center lg:text-left leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {step.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MATimeline;